import { Sort, TrainingsTrainingRequestStatusEnum } from 'generated/resources/graphql'

interface MapVariablesInput {
  filters: Record<string, unknown>
  search?: string
  sortings?: ReadonlyArray<{ field: string; order: string }>
}

interface MappedVariables {
  companyId: string
  search?: string
  authorId?: string
  employeesOrAuthor: boolean
  status?: TrainingsTrainingRequestStatusEnum
  sortOrder?: Sort
}

const VALID_REQUEST_STATUSES: TrainingsTrainingRequestStatusEnum[] = [
  'draft',
  'review',
  'approved',
  'rejected',
]
const validRequestStatusSet = new Set<string>(VALID_REQUEST_STATUSES)
const isValidRequestStatus = (v: string): v is TrainingsTrainingRequestStatusEnum =>
  validRequestStatusSet.has(v)

export const buildMapVariables = (companyId: string) => {
  return ({ filters, search, sortings }: MapVariablesInput): MappedVariables => {
    let status: TrainingsTrainingRequestStatusEnum | undefined = undefined
    const rawStatus =
      Array.isArray(filters.status) && filters.status.length > 0
        ? String(filters.status[0])
        : filters.status
          ? String(filters.status)
          : undefined
    if (rawStatus && isValidRequestStatus(rawStatus)) {
      status = rawStatus
    }

    const authorId =
      Array.isArray(filters.applicant)
        ? filters.applicant.length > 0
          ? String(filters.applicant[0])
          : undefined
        : filters.applicant
          ? String(filters.applicant)
          : undefined

    return {
      companyId,
      search,
      authorId,
      employeesOrAuthor: true,
      status,
      sortOrder: sortings?.[0],
    }
  }
}
